/** Present catalogue names and saved transaction labels consistently without changing stored data. */
export function phoneModelLabel(value: string): string {
  return value.replace(/\b(\d+)\s*GB\s*\/\s*(\d+)\s*GB\s+RAM\b/gi, '$2GB + $1GB');
}

/** Only model-label fields are projected; identifiers, brand spelling and numeric specs stay intact. */
export function presentPhoneModels<T>(value: T): T {
  if (Array.isArray(value)) return value.map(item => presentPhoneModels(item)) as T;
  if (!value || typeof value !== 'object') return value;
  const row = value as Record<string, unknown>;
  return Object.fromEntries(Object.entries(row).map(([key, item]) => {
    const modelLabel = key === 'skuName'
      || (key === 'displayName' && typeof row.skuCode === 'string')
      || (key === 'name' && typeof row.skuId === 'string');
    return [key, modelLabel && typeof item === 'string' ? phoneModelLabel(item) : presentPhoneModels(item)];
  })) as T;
}
